import { useSelector } from 'react-redux';
import { userSelectors } from '../../../../store/modules/user';

const useUserTimeList = () => {
  const max = useSelector(userSelectors.selectMaxText2VideoProjectDuration);

  return max || 10;
};

export default useUserTimeList;
